import { Navigate, Route, Routes } from 'react-router';
import { useSession } from '@/lib/session';
import Layout from '@/components/Layout';
import Login from '@/pages/Login';
import Home from '@/pages/Home';
import QuotePage from '@/pages/QuotePage';
import MyAccount from '@/pages/MyAccount';
import Accounts from '@/pages/Accounts';

export default function App() {
  const { session, isLoading, isError } = useSession();

  if (isLoading) {
    return (
      <div className="text-muted-foreground flex min-h-full items-center justify-center">
        Chargement…
      </div>
    );
  }

  if (isError) {
    return (
      <div className="flex min-h-full flex-col items-center justify-center gap-3 p-8 text-center">
        <p className="text-destructive font-medium">Serveur injoignable.</p>
        <p className="text-muted-foreground text-sm">
          Vérifiez la connexion réseau, puis rechargez la page.
        </p>
      </div>
    );
  }

  if (!session) return <Login />;

  const isAdmin = session.user.role === 'ADMIN';

  return (
    <Layout session={session}>
      <Routes>
        <Route path="/" element={<Home session={session} />} />
        <Route path="/commandes/:id" element={<QuotePage />} />
        <Route path="/compte" element={<MyAccount session={session} />} />
        {isAdmin && <Route path="/admin/comptes" element={<Accounts session={session} />} />}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}
